export const billingApiEndpoints: Record<string, string> = {
  myBilling: "/ext/billing/mine/",
  startCheckout: "POST:/ext/billing/checkout/",
  stopBilling: "POST:/ext/billing/stop/",
  platformBilling: "/ext/billing/platform/",
  savePrices: "PUT:/ext/billing/platform/prices/",
  saveBillingTerms: "PUT:/ext/billing/platform/:pk/",
  uploadProof: "POST:/ext/billing/invoices/:pk/proof/",
  issueInvoice: "POST:/ext/billing/platform/:pk/invoice/",
  decideInvoice: "POST:/ext/billing/platform/invoices/:pk/decide/",
  saveBankDetails: "PUT:/ext/billing/platform/bank-details/",
  platformRevenue: "/ext/billing/platform/revenue/",
  receipts: "/ext/billing/receipts/",
  receipt: "/ext/billing/receipts/:pk/",
  invoiceRecord: "/ext/billing/invoices/:pk/record/",
  sayOnInvoice: "POST:/ext/billing/invoices/:pk/record/",
};
